export const roles = {
  admin: "admin",
  na: "na",
};

export default class User {
  role: string = roles.na;
  data: UserData = new UserData();
  uid = "";

  // Only used for user interface
  dirty: boolean | null = false;
  password: string | null = null;

  client: string | null = null;
}

export class UserData {
  email = "";
  displayName: string | null = "";
}
